import clsx from "clsx";
import { BadgeCheck } from "lucide-react";
import { matchPath, useLocation } from "react-router-dom";

import { onboardingSteps } from "../configs/onboarding-steps";

export function OnboardingNavigation() {
  const location = useLocation();

  const currentStep = onboardingSteps.findIndex(
    (step) => matchPath(step.slug, location.pathname) !== null,
  );

  return (
    <div className="flow-root">
      <ul role="list" className="-mb-8">
        {onboardingSteps.map((step, stepIdx) => {
          const isActive = matchPath(step.slug, location.pathname) !== null;
          const isCompleted = stepIdx < currentStep;
          const isDisabled = stepIdx > currentStep;

          return (
            <li key={step.slug}>
              <div className="relative pb-8">
                {stepIdx !== onboardingSteps.length - 1 ? (
                  <span
                    aria-hidden="true"
                    className="absolute left-[21px] -ml-px h-full w-0.5 bg-border"
                  />
                ) : null}
                <div className={clsx("relative flex space-x-6")}>
                  <div className="flex h-11 w-11 items-center justify-center">
                    <div
                      className={clsx(
                        "inline-flex items-center justify-center rounded-xl border border-border bg-background p-3 shadow-sm dark:text-white",
                        {
                          "bg-primary text-background dark:border-primary dark:bg-background":
                            isActive,
                          "bg-background": !isActive,
                          "bg-[#fcfcfc]": isDisabled,
                        },
                      )}
                    >
                      {isCompleted ? (
                        <BadgeCheck
                          className="h-5 w-5 text-green-600"
                          aria-hidden="true"
                        />
                      ) : (
                        <step.icon
                          className={clsx(
                            "h-5 w-5",
                            isDisabled ? "opacity-60" : "",
                          )}
                          aria-hidden="true"
                        />
                      )}
                    </div>
                  </div>
                  <div
                    className={clsx(
                      "flex min-w-0 flex-1 justify-between space-x-4",
                      isDisabled ? "opacity-60" : "",
                    )}
                  >
                    <p className="text-md">
                      <span className="mb-0.5 block font-semibold text-secondary">
                        {step.title}
                      </span>
                      <span className="inline-block text-muted">
                        {step.description}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
